export function getLoginMethod(state) {
  return state.auth.loginMethod;
}



// WEBPACK FOOTER //
// ./src/modules/auth/auth-selectors.js